import { Helmet } from 'react-helmet-async'
import { useState, useEffect } from 'react'
import { db } from '../lib/supabase'

export default function Contacto() {
  const [formData, setFormData] = useState({
    nombre_empresa: '',
    nombre_contacto: '',
    ruc: '',
    email: '',
    telefono: '',
    mensaje: ''
  })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [seoConfig, setSeoConfig] = useState(null)
  const [faqs, setFaqs] = useState([])

  useEffect(() => {
    loadSEOConfig()
    loadFAQs()
  }, [])

  const loadSEOConfig = async () => {
    const { data } = await db.getSEOConfig('contacto')
    setSeoConfig(data || null)
  }

  const loadFAQs = async () => {
    const { data } = await db.getFAQsByScope('page', null, 'contacto')
    setFaqs(data || [])
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    
    const { error } = await db.createContactoMarca(formData)
    
    if (error) {
      alert('Error al enviar el formulario')
    } else {
      setSuccess(true)
      setFormData({
        nombre_empresa: '',
        nombre_contacto: '',
        ruc: '',
        email: '',
        telefono: '',
        mensaje: ''
      })
    }
    
    setLoading(false)
  }

  return (
    <>
      <Helmet>
        <title>{seoConfig?.meta_title || 'Contacto - Plaza Aurora'}</title>
        <meta name="description" content={seoConfig?.meta_description || '¿Quieres formar parte de Plaza Aurora Outlet? Contáctanos'} />
        <link rel="canonical" href={seoConfig?.canonical_url || `${import.meta.env.VITE_SITE_URL || 'https://plazaaurora.pe'}/contacto`} />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_PE" />
        <meta property="og:site_name" content="Plaza Aurora" />
        <meta property="og:url" content={seoConfig?.canonical_url || `${import.meta.env.VITE_SITE_URL || 'https://plazaaurora.pe'}/contacto`} />
        <meta property="og:title" content={seoConfig?.og_title || seoConfig?.meta_title || 'Contacto - Plaza Aurora'} />
        <meta property="og:description" content={seoConfig?.og_description || seoConfig?.meta_description || '¿Quieres formar parte de Plaza Aurora Outlet? Contáctanos'} />
        {seoConfig?.og_image_url && <meta property="og:image" content={seoConfig.og_image_url} />}
        
        {/* Twitter Card */}
        <meta name="twitter:card" content={seoConfig?.twitter_card || 'summary_large_image'} />
        <meta name="twitter:title" content={seoConfig?.og_title || seoConfig?.meta_title || 'Contacto - Plaza Aurora'} />
        <meta name="twitter:description" content={seoConfig?.og_description || seoConfig?.meta_description || '¿Quieres formar parte de Plaza Aurora Outlet? Contáctanos'} />
        {seoConfig?.og_image_url && <meta name="twitter:image" content={seoConfig.og_image_url} />}
        
        {/* Robots */}
        <meta name="robots" content={seoConfig?.robots_index === false ? 'noindex,nofollow' : 'index,follow'} />
      </Helmet>
      
      {seoConfig?.json_ld && (
        <script type="application/ld+json">
          {seoConfig.json_ld}
        </script>
      )}
      
      {/* Hero Section */}
      <div style={{
        background: 'var(--color-black-block)',
        color: '#FFFFFF',
        padding: '4rem 0',
        textAlign: 'center',
        marginTop: '4.5rem'
      }}>
        <div style={{
          maxWidth: 'var(--container-max-width)',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 5vw, 3rem)',
            fontWeight: '700',
            fontFamily: 'var(--font-display)',
            marginBottom: '1rem',
            lineHeight: '1.2',
            letterSpacing: '0.02em'
          }}>CONTACTO PARA MARCAS</h1>
          <p style={{
            fontSize: 'var(--font-size-h3)',
            fontFamily: 'var(--font-ui)',
            opacity: 0.95
          }}>¿Quieres formar parte de Plaza Aurora Outlet?</p>
        </div>
      </div>

      {/* Form Section */}
      <div style={{
        maxWidth: 'var(--container-max-width)',
        margin: '0 auto',
        padding: '4rem 2rem'
      }}>
        <div style={{
          maxWidth: '672px',
          margin: '0 auto'
        }}>
          {success ? (
            <div style={{
              background: '#D1FAE5',
              color: '#065F46',
              padding: '2rem',
              borderRadius: 'var(--radius-md)',
              textAlign: 'center'
            }}>
              <h2 style={{
                fontSize: 'var(--font-size-h2)',
                fontWeight: '700',
                fontFamily: 'var(--font-display)',
                marginBottom: '0.5rem'
              }}>¡GRACIAS POR CONTACTARNOS!</h2>
              <p style={{
                fontSize: 'var(--font-size-body)',
                fontFamily: 'var(--font-ui)'
              }}>Nos pondremos en contacto contigo pronto.</p>
            </div>
          ) : (
            <div style={{
              background: 'white',
              borderRadius: 'var(--radius-lg)',
              padding: '2rem'
            }}>
              <h2 style={{
                fontSize: 'var(--font-size-h2)',
                fontWeight: '700',
                fontFamily: 'var(--font-display)',
                color: 'var(--color-text-primary)',
                marginBottom: '1.5rem',
                textAlign: 'center'
              }}>FORMULARIO DE CONTACTO</h2>

              <form onSubmit={handleSubmit} style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1.5rem'
              }}>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: 'var(--font-size-small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--color-text-primary)',
                    marginBottom: '0.5rem'
                  }}>Nombre de la Empresa *</label>
                  <input
                    type="text"
                    required
                    value={formData.nombre_empresa}
                    onChange={(e) => setFormData({...formData, nombre_empresa: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '0.75rem 1rem',
                      border: '1px solid var(--color-stroke)',
                      borderRadius: 'var(--radius-sm)',
                      fontSize: 'var(--font-size-body)',
                      fontFamily: 'var(--font-ui)',
                      color: 'var(--color-text-primary)',
                      transition: 'border-color 0.2s ease'
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.outline = 'none'
                      e.currentTarget.style.borderColor = 'var(--brand-blue)'
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-blue-200)'
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = 'var(--color-stroke)'
                      e.currentTarget.style.boxShadow = 'none'
                    }}
                  />
                </div>

                <div>
                  <label style={{
                    display: 'block',
                    fontSize: 'var(--font-size-small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--color-text-primary)',
                    marginBottom: '0.5rem'
                  }}>Nombre de Contacto *</label>
                  <input
                    type="text"
                    required
                    value={formData.nombre_contacto}
                    onChange={(e) => setFormData({...formData, nombre_contacto: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '0.75rem 1rem',
                      border: '1px solid var(--color-stroke)',
                      borderRadius: 'var(--radius-sm)',
                      fontSize: 'var(--font-size-body)',
                      fontFamily: 'var(--font-ui)',
                      color: 'var(--color-text-primary)',
                      transition: 'border-color 0.2s ease'
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.outline = 'none'
                      e.currentTarget.style.borderColor = 'var(--brand-blue)'
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-blue-200)'
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = 'var(--color-stroke)'
                      e.currentTarget.style.boxShadow = 'none'
                    }}
                  />
                </div>

                <div>
                  <label style={{
                    display: 'block',
                    fontSize: 'var(--font-size-small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--color-text-primary)',
                    marginBottom: '0.5rem'
                  }}>RUC</label>
                  <input
                    type="text"
                    maxLength={11}
                    value={formData.ruc}
                    onChange={(e) => setFormData({...formData, ruc: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '0.75rem 1rem',
                      border: '1px solid var(--color-stroke)',
                      borderRadius: 'var(--radius-sm)',
                      fontSize: 'var(--font-size-body)',
                      fontFamily: 'var(--font-ui)',
                      color: 'var(--color-text-primary)',
                      transition: 'border-color 0.2s ease'
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.outline = 'none'
                      e.currentTarget.style.borderColor = 'var(--brand-blue)'
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-blue-200)'
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = 'var(--color-stroke)'
                      e.currentTarget.style.boxShadow = 'none'
                    }}
                  />
                </div>

                <div>
                  <label style={{
                    display: 'block',
                    fontSize: 'var(--font-size-small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--color-text-primary)',
                    marginBottom: '0.5rem'
                  }}>Email *</label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '0.75rem 1rem',
                      border: '1px solid var(--color-stroke)',
                      borderRadius: 'var(--radius-sm)',
                      fontSize: 'var(--font-size-body)',
                      fontFamily: 'var(--font-ui)',
                      color: 'var(--color-text-primary)',
                      transition: 'border-color 0.2s ease'
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.outline = 'none'
                      e.currentTarget.style.borderColor = 'var(--brand-blue)'
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-blue-200)'
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = 'var(--color-stroke)'
                      e.currentTarget.style.boxShadow = 'none'
                    }}
                  />
                </div>

                <div>
                  <label style={{
                    display: 'block',
                    fontSize: 'var(--font-size-small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--color-text-primary)',
                    marginBottom: '0.5rem'
                  }}>Teléfono</label>
                  <input
                    type="tel"
                    value={formData.telefono}
                    onChange={(e) => setFormData({...formData, telefono: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '0.75rem 1rem',
                      border: '1px solid var(--color-stroke)',
                      borderRadius: 'var(--radius-sm)',
                      fontSize: 'var(--font-size-body)',
                      fontFamily: 'var(--font-ui)',
                      color: 'var(--color-text-primary)',
                      transition: 'border-color 0.2s ease'
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.outline = 'none'
                      e.currentTarget.style.borderColor = 'var(--brand-blue)'
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-blue-200)'
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = 'var(--color-stroke)'
                      e.currentTarget.style.boxShadow = 'none'
                    }}
                  />
                </div>

                <div>
                  <label style={{
                    display: 'block',
                    fontSize: 'var(--font-size-small)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    color: 'var(--color-text-primary)',
                    marginBottom: '0.5rem'
                  }}>Mensaje *</label>
                  <textarea
                    required
                    rows={6}
                    value={formData.mensaje}
                    onChange={(e) => setFormData({...formData, mensaje: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '0.75rem 1rem',
                      border: '1px solid var(--color-stroke)',
                      borderRadius: 'var(--radius-sm)',
                      fontSize: 'var(--font-size-body)',
                      fontFamily: 'var(--font-ui)',
                      color: 'var(--color-text-primary)',
                      transition: 'border-color 0.2s ease',
                      resize: 'vertical'
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.outline = 'none'
                      e.currentTarget.style.borderColor = 'var(--brand-blue)'
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-blue-200)'
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = 'var(--color-stroke)'
                      e.currentTarget.style.boxShadow = 'none'
                    }}
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    width: '100%',
                    padding: '0.875rem 2rem',
                    background: loading ? 'var(--color-text-muted)' : 'var(--color-cta-bg)',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: 'var(--radius-sm)',
                    fontSize: 'var(--font-size-body)',
                    fontWeight: '500',
                    fontFamily: 'var(--font-ui)',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s ease',
                    letterSpacing: '0.02em'
                  }}
                  onMouseEnter={(e) => {
                    if (!loading) {
                      e.currentTarget.style.transform = 'translateY(-2px)'
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-blue-200)'
                      e.currentTarget.style.background = 'var(--brand-blue)'
                      e.currentTarget.style.color = 'white'
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!loading) {
                      e.currentTarget.style.transform = 'translateY(0)'
                      e.currentTarget.style.boxShadow = 'none'
                      e.currentTarget.style.background = 'var(--color-cta-bg)'
                      e.currentTarget.style.color = '#FFFFFF'
                    }
                  }}
                  onMouseDown={(e) => {
                    if (!loading) {
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-blue-400)'
                      e.currentTarget.style.background = 'var(--brand-blue-600)'
                    }
                  }}
                >
                  {loading ? 'ENVIANDO...' : 'ENVIAR MENSAJE'}
                </button>
              </form>
            </div>
          )}
        </div>

        {/* FAQs Section */}
        {faqs.length > 0 && (
          <section id="faqs" role="region" aria-label="Preguntas Frecuentes" style={{ marginTop: '3rem', maxWidth: '800px', margin: '3rem auto 0' }}>
            <h2 style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'var(--font-size-display-l)',
              fontWeight: 'var(--font-weight-bold)',
              color: 'var(--color-text-primary)',
              textAlign: 'center',
              marginBottom: '2rem'
            }}>Preguntas Frecuentes</h2>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem'
            }}>
              {faqs.map((faq) => (
                <details key={faq.id} style={{
                  background: 'var(--color-surface)',
                  borderRadius: 'var(--radius-lg)',
                  padding: '1.5rem',
                  border: '1px solid var(--color-stroke)',
                  cursor: 'pointer'
                }}>
                  <summary style={{
                    fontFamily: 'var(--font-ui)',
                    fontSize: 'var(--font-size-h4)',
                    fontWeight: 'var(--font-weight-semibold)',
                    color: 'var(--color-text-primary)',
                    listStyle: 'none',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    {faq.pregunta}
                    <span style={{ fontSize: '1.5rem', marginLeft: '1rem' }}>+</span>
                  </summary>
                  <p style={{
                    fontFamily: 'var(--font-ui)',
                    fontSize: 'var(--font-size-body)',
                    color: 'var(--color-text-muted)',
                    lineHeight: '1.6',
                    marginTop: '1rem',
                    whiteSpace: 'pre-line'
                  }}>
                    {faq.respuesta}
                  </p>
                </details>
              ))}
            </div>
            
            {/* FAQPage JSON-LD */}
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": faqs.map(faq => ({
                  "@type": "Question",
                  "name": faq.pregunta,
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": faq.respuesta
                  }
                }))
              })}
            </script>
          </section>
        )}
      </div>
    </>
  )
}
